
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI2(formattedTitle, formattedPrice, i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function repeatI3(formattedTitle, formattedPrice, i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function repeatVariant_id4(formattedTitle, formattedPrice, variant_id, variant_idIndex) {
                    return _createElement('option', {
                        'value': variant_id,
                        'data-price': (this.price || 0) * 100,
                        'data-inventory-quantity': '1',
                        'data-inventory-management': 'shopify',
                        'data-inventory-policy': 'deny',
                        'data-availability': 'true',
                        'key': variant_id
                    });
                }
                function onClick5(formattedTitle, formattedPrice, e) {
                    window.globalListeners.closeQuickAddPopup(e);
                }
                function scopeFormattedTitleFormattedPrice6() {
                    var formattedTitle = this.removeHTML(this.title);
                    var formattedPrice = this.formatPrice(this.price);
                    return _createElement('div', { 'className': 'product-card-container' }, _createElement('div', {
                        'product-card': 'true',
                        'className': 'product-card',
                        'data-product-id': this.id,
                        'data-test': 'true',
                        'data-cart-link-text': 'View'
                    }, _createElement('div', {}, _createElement('a', {
                        'href': this.url,
                        'className': 'product-image',
                        'atia-label': 'Link to ' + formattedTitle
                    }, _createElement('img', {
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'alt': formattedTitle,
                        'onError': this.onImageError,
                        'width': '400',
                        'height': '400',
                        'loading': 'eager',
                        'fetchpriority': 'high'
                    }), this.image2 ? _createElement('img', {
                        'src': this.resizeImage(this.image2),
                        'alt': formattedTitle,
                        'onError': e => this.onImageError(e, 'image2'),
                        'width': '400',
                        'height': '400',
                        'loading': 'eager',
                        'fetchpriority': 'high',
                        'className': 'image-hover',
                        'key': '558'
                    }) : null, _createElement('div', { 'className': 'wishlist-heart' }, _createElement('button', {
                        'type': 'button',
                        'aria-label': 'Add to wishlist',
                        'className': 'button-wishlist',
                        'button-wishlist': 'true',
                        'data-product-handle': this.handle,
                        'data-product-id': this.id
                    }, _createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '33',
                        'height': '28.88',
                        'viewBox': '0 0 23.023 21.252'
                    }, _createElement('path', {
                        'id': 'Icon_ionic-md-heart-empty',
                        'data-name': 'Icon ionic-md-heart-empty',
                        'd': 'M20.067,4.5a6.81,6.81,0,0,0-5.18,2.43A6.81,6.81,0,0,0,9.706,4.5a6.259,6.259,0,0,0-6.331,6.37c0,4.4,3.913,7.931,9.84,13.377l1.671,1.505,1.671-1.505C22.485,18.8,26.4,15.27,26.4,10.87A6.259,6.259,0,0,0,20.067,4.5ZM15.595,22.725l-.232.216-.476.432-.476-.432-.232-.216a70.345,70.345,0,0,1-6.791-6.752c-1.55-1.92-2.236-3.492-2.236-5.1A4.6,4.6,0,0,1,6.463,7.588,4.5,4.5,0,0,1,9.706,6.271a5.076,5.076,0,0,1,3.824,1.8l1.356,1.61,1.356-1.61a5.057,5.057,0,0,1,3.824-1.8,4.526,4.526,0,0,1,3.249,1.317,4.613,4.613,0,0,1,1.312,3.282c0,1.6-.692,3.182-2.236,5.1A70.487,70.487,0,0,1,15.595,22.725Z',
                        'transform': 'translate(-3.375 -4.5)'
                    })))), _createElement('div', { 'className': 'product-badges' }, this.on_sale && this.price && this.compare_at_price ? _createElement('div', {
                        'className': 'product-badge top-left rectangle cm_sale-badge',
                        'key': '1918'
                    }, _createElement('div', { 'className': 'badge-image' }, _createElement('svg', {
                        'className': 'badge-image-icon',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '18.097',
                        'height': '18.097',
                        'viewBox': '0 0 18.097 18.097'
                    }, _createElement('path', {
                        'd': 'M11.3,3a8.3,8.3,0,1,0,5.532,2.113M7.61,14.986,14.986,7.61m.922,6.454a1.844,1.844,0,1,1-1.844-1.844A1.844,1.844,0,0,1,15.909,14.064ZM10.376,8.532A1.844,1.844,0,1,1,8.532,6.688,1.844,1.844,0,0,1,10.376,8.532Z',
                        'transform': 'translate(-2.25 -2.25)',
                        'fill': 'none',
                        'stroke': '#000',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round',
                        'strokeWidth': '1.5'
                    }))), '\n            ', Math.round(this.calcDiscount(this.price, this.compare_at_price)), '% off\n          ') : null, this.has_new_badge ? _createElement('div', {
                        'className': 'product-badge top-left rectangle cm_new-badge',
                        'key': '2742'
                    }, 'New') : null)), _createElement('a', mergeProps({
                        'href': this.url,
                        'className': 'product-title'
                    }, { dangerouslySetInnerHTML: { __html: this.title } }))), _createElement('div', {}, this.price > 0 ? _createElement('div', {
                        'className': 'product-price',
                        'data-price': this.price * 100,
                        'data-product-id': this.id,
                        'key': '3002'
                    }, !this.on_sale ? _createElement('div', {
                        'className': 'prices',
                        'key': '3124'
                    }, [this.review_count ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_review-stars',
                                'key': '31770'
                            },
                            _map([
                                0,
                                1,
                                2,
                                3,
                                4
                            ], repeatI2.bind(this, formattedTitle, formattedPrice)),
                            _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                        ]) : null], _createElement('span', {}, formattedPrice)) : null, this.on_sale ? [
                        _createElement('div', {
                            'className': 'product-reviews-save',
                            'key': '36371'
                        }, _createElement('div', { 'className': 'reviews' }, [this.review_count ? _createElement.apply(this, [
                                'div',
                                {
                                    'className': 'cm_review-stars',
                                    'key': '37640'
                                },
                                _map([
                                    0,
                                    1,
                                    2,
                                    3,
                                    4
                                ], repeatI3.bind(this, formattedTitle, formattedPrice)),
                                _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                            ]) : null]), _createElement('div', { 'className': 'save' }, 'Save ', this.formatPrice(this.compare_at_price - this.price))),
                        _createElement('div', {
                            'className': 'prices',
                            'key': '36373'
                        }, _createElement('span', { 'className': 'cm_product-item__price_compare' }, this.formatPrice(this.compare_at_price)), _createElement('span', { 'className': 'cm_product-item__price_sale' }, formattedPrice))
                    ] : null) : null, _createElement('div', { 'className': 'product-buttons' }, _createElement('a', {
                        'href': this.url,
                        'className': 'product-link'
                    }, 'View Product'), _createElement('div', {
                        'quick-add-popup': 'true',
                        'className': 'quick-add-popup'
                    }, _createElement('div', { 'className': 'product-form' }, _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'id': 'product_form_' + this.id,
                        'acceptCharset': 'UTF-8',
                        'className': 'shopify-product-form',
                        'encType': 'multipart/form-data',
                        'data-section-id': 'cm_results',
                        'data-add-to-cart': 'Buy now',
                        'data-sold-out': 'Sold out',
                        'data-unavailable': 'Unavailable',
                        'data-money-format': formattedPrice,
                        'data-option-name-one': this.product_data_webdropdown1label,
                        'data-option-name-two': this.product_data_webdropdown2label,
                        'data-option-name-three': this.product_data_webdropdown3label
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'form_type',
                        'value': 'product'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'utf8',
                        'value': '\u2713'
                    }), _createElement('div', { 'className': 'product-title-wrapper' }, _createElement('div', { 'className': 'title-reviews' }, _createElement('a', {
                        'href': this.url,
                        'className': 'product-title'
                    }, formattedTitle)), _createElement('div', { 'className': 'quick-code-container' }, _createElement('div', { 'className': 'variant-sku' }, 'Quick Code: ', _createElement('span', { 'variant-sku': this.sku }, this.sku)))), _createElement('div', { 'className': 'variant-selector-wrapper' }, _createElement.apply(this, [
                        'select',
                        {
                            'style': { display: 'none' },
                            'name': 'id',
                            'id': 'product-id-cm_results-' + this.id
                        },
                        _map(this.variant_ids, repeatVariant_id4.bind(this, formattedTitle, formattedPrice))
                    ])), _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'variant-prices-container' }, _createElement('div', { 'className': 'variant-price-wrapper' }, _createElement('span', {
                        'data-variant-price': (this.price || 0) * 100,
                        'className': 'heading-md main-price',
                        'data-money-format': formattedPrice
                    }, '\n                      ', formattedPrice, '\n                    ')))), _createElement('div', { 'className': 'product-submit-wrapper' }, _createElement('div', { 'className': 'quantity-total-wrapper' }, _createElement('div', { 'className': 'quantity-wrapper' }, _createElement('div', {
                        'quantity-select': 'true',
                        'className': 'quantity-select'
                    }, _createElement('div', {
                        'quantity-minus': 'true',
                        'className': 'minus'
                    }, '-'), _createElement('div', {
                        'quantity': '1',
                        'className': 'quantity'
                    }, '1'), _createElement('div', {
                        'quantity-plus': 'true',
                        'className': 'plus'
                    }, '+'), _createElement('input', {
                        'style': { display: 'none !important' },
                        'type': 'number',
                        'name': 'quantity',
                        'value': '1',
                        'min': '1',
                        'max': '9999',
                        'className': 'quantity-selector quantity-input',
                        'data-money-format': formattedPrice
                    })))), _createElement('label', { 'className': 'submit-with-svg button-3' }, _createElement('img', {
                        'src': '//ghostbikes-store.myshopify.com/cdn/shop/t/2/assets/cart-add.svg?v=28676871941298473791715078894',
                        'alt': 'Buy now',
                        'width': '17px',
                        'height': '15px'
                    }), _createElement('input', {
                        'type': 'submit',
                        'value': 'Buy now',
                        'add-to-cart': 'true',
                        'aria-label': 'Add ' + formattedTitle + ' to the basket',
                        'data-section-id': 'cm_results',
                        'data-id': this.variant_ids[0],
                        'data-default-variant': true,
                        'data-product-handle': this.handle,
                        'data-quantity': '1'
                    }))), _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'section-id',
                        'value': 'cm_results'
                    }))), _createElement('div', { 'className': 'close-quick-add-wrapper' }, _createElement('a', { 'href': this.url }, 'View full product info'), _createElement('button', {
                        'close-quick-add-trigger': 'true',
                        'className': 'close-quick-add',
                        'onClick': onClick5.bind(this, formattedTitle, formattedPrice)
                    }, _createElement('svg', {
                        'clipRule': 'evenodd',
                        'fillRule': 'evenodd',
                        'strokeLinejoin': 'round',
                        'strokeMiterlimit': '2',
                        'viewBox': '0 0 24 24',
                        'xmlns': 'http://www.w3.org/2000/svg'
                    }, _createElement('path', {
                        'd': 'm14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z',
                        'fillRule': 'nonzero'
                    }))))), _createElement('button', {
                        'className': 'quick-add-trigger',
                        'aria-label': 'Add ' + formattedTitle + ' to the cart',
                        'data-section-id': 'cm_results',
                        'data-id': this.variant_ids[0],
                        'data-product-handle': this.handle,
                        'data-default-variant': this.variant_ids.length === 1 ? 'true' : '',
                        'data-quantity': '1',
                        'quick-add-trigger': 'true',
                        'disabled': this.out_of_stock
                    }, !this.out_of_stock ? _createElement('img', {
                        'src': '//ghostbikes-store.myshopify.com/cdn/shop/t/2/assets/cart-add.svg?v=28676871941298473791715078894',
                        'width': '30',
                        'height': '30',
                        'alt': 'Add to cart',
                        'key': '9339'
                    }) : null, '\n          ', this.out_of_stock ? 'Sold out' : 'Buy now', '\n        ')))));
                }
                return scopeFormattedTitleFormattedPrice6.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []